import { render, staticRenderFns } from "./segmentRemarketing.vue?vue&type=template&id=1e267ec6&"
import script from "./segmentRemarketing.vue?vue&type=script&lang=js&"
export * from "./segmentRemarketing.vue?vue&type=script&lang=js&"
import style0 from "./segmentRemarketing.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports